import React, { useEffect, useState } from "react";
import axios from "axios";
import { BookOpen, Medal } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BADGE_STYLES = {
  or: { bg: "#FBBF24", text: "#1E3A8A", label: "Lecteur d'Or" },
  argent: { bg: "#CBD5E1", text: "#334155", label: "Lecteur d'Argent" },
  bronze: { bg: "#CD7F32", text: "#fff", label: "Lecteur de Bronze" },
};

export const TopReaders = () => {
  const [readers, setReaders] = useState([]);

  useEffect(() => {
    axios.get(`${API}/library/top-readers`).then(({ data }) => setReaders(data)).catch(() => {});
  }, []);

  if (readers.length === 0) return null;

  return (
    <div className="mt-14" data-testid="top-readers-section">
      <div className="flex items-center gap-3 mb-5">
        <BookOpen className="h-6 w-6 text-[#166534]" />
        <h2 className="font-heading font-extrabold text-2xl text-[#1E3A8A]">Meilleurs lecteurs de l&apos;école</h2>
        <div className="flex-1 h-px bg-gradient-to-r from-[#166534] to-transparent" />
      </div>
      <p className="text-sm text-slate-500 mb-6">
        Bravo à nos élèves les plus assidus de la bibliothèque ! Badges : 🥇 Or (10+ lectures) · 🥈 Argent (5+) · 🥉 Bronze (2+)
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {readers.map((r, i) => {
          const style = r.badge ? BADGE_STYLES[r.badge.level] : null;
          return (
            <div key={i} className="bg-white border border-slate-200 rounded-xl p-4 hover:shadow-lg transition-all hover:-translate-y-1" data-testid={`top-reader-${i}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs font-bold text-slate-400">#{i + 1}</span>
                {style && (
                  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase px-2 py-1 rounded-full" style={{ backgroundColor: style.bg, color: style.text }}>
                    <Medal className="h-3 w-3" /> {style.label}
                  </span>
                )}
              </div>
              <div className="font-heading font-bold text-sm text-[#0F172A] truncate" title={r.student_name}>{r.student_name}</div>
              <div className="text-xs text-slate-500">{r.class_name}</div>
              <div className="mt-2 text-2xl font-extrabold text-[#166534] tabular-nums">
                {r.books_read} <span className="text-xs font-semibold text-slate-400">livre{r.books_read > 1 ? "s" : ""} emprunté{r.books_read > 1 ? "s" : ""}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
